
const FORGOT_PASSWORD_LOCALE_TEMPLATES = {
    "en": {
        "forgot.password.title.mobile": "Forgot your password?",
        "forgot.password.title": "Forgot your <br/> password?",
        "forgot.password.email": "Email",
        "forgot.password.button.label": "Send link",
        "forgot.password.back.to.sign.in.route": "back to login",
        "forgot.password.expired.link.used": "Link expired",

        "forgot.password.popup.email.not.valid": "Email is not valid",
        "forgot.password.popup.reset.email.sent": "Reset email is sent",
    },
    "nl": {
        "forgot.password.title.mobile": "Wachtwoord vergeten?",
        "forgot.password.title": "Wachtwoord <br /> vergeten?",
        "forgot.password.email": "Emailadres",
        "forgot.password.button.label": "Link sturen",
        "forgot.password.back.to.sign.in.route": "terug naar login",
        "forgot.password.expired.link.used": "Link verlopen",

        "forgot.password.popup.email.not.valid": "E-mailadres is ongeldig",
        "forgot.password.popup.reset.email.sent": "Reset-e-mail is verzonden",
    }
}

export default FORGOT_PASSWORD_LOCALE_TEMPLATES;